import React from 'react';
import { Smartphone, Monitor, ShoppingBag } from 'lucide-react';

export const MobileWarning: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="mb-6 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-amber-500 rounded-full blur-xl opacity-20 animate-pulse"></div>
            <div className="relative bg-amber-500 rounded-full p-6">
              <Smartphone className="w-12 h-12 text-white" />
            </div>
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-3">
          Application Desktop
        </h1>
        
        <div className="flex items-center justify-center text-slate-500 mb-6">
          <Monitor className="w-5 h-5 mr-2" />
          <span className="text-sm">Optimisée pour ordinateur</span>
        </div>
        
        <p className="text-slate-600 mb-8 leading-relaxed">
          Cette application est optimisée pour un usage sur ordinateur. 
          Pour une meilleure expérience sur mobile, veuillez installer l'application mobile iOS.
        </p>
        
        <div className="mb-6">
          <button
            disabled
            className="w-full bg-slate-300 text-slate-500 px-6 py-4 rounded-lg font-semibold flex items-center justify-center cursor-not-allowed opacity-60"
          >
            <ShoppingBag className="w-5 h-5 mr-2" />
            <span>Disponible sur l'App Store</span>
          </button>
          <p className="text-xs text-slate-400 mt-2">À venir</p>
        </div>
        
        <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
          <p className="text-xs text-slate-500">
            Pour accéder à toutes les fonctionnalités, veuillez utiliser cette application sur un ordinateur.
          </p>
        </div>
      </div>
    </div>
  );
};
